import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  identity: {
    documentId: '',
    concessionId: '',
    zipCode: '',
    vehicleId: '',
    vin: ''
  },
  concessions: null,
  componentsCMS: null,
  legalConditions: null,
  act: null,
  risk: null,
  checklistAccessories: [],
  checklistDocumentationAndEquip: [],
  interiorDamage: [],
  bodyDamage: [],
  errorIdentity: null,
  errorNotConcessions: null,
  errorGetConcessions: null,
  anotherDelivery: {
    status: false,
    name: '',
    lastname: '',
    lastname2: '',
    contactInfo: {
      mobile: '',
      email: ''
    },
    documentId: '',
    documents: []
  },
  readDocumentation: {
    kmCount: 0,
    documents: []
  },
  externalBreaksDocumentation: {
    documents: []
  },
  internalBreaksDocumentation: {
    documents: []
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
